import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface AuthUser {
  id: string
  email: string
  nombre: string
  rol: 'ADMIN' | 'SUPERVISOR' | 'AUDITOR'
  tenantId: string
}

interface AuthState {
  token: string | null
  refreshToken: string | null
  usuario: AuthUser | null
  login: (token: string, refreshToken: string, usuario: AuthUser) => void
  logout: () => void
  setToken: (token: string) => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      refreshToken: null,
      usuario: null,
      login(token, refreshToken, usuario) {
        set({ token, refreshToken, usuario })
      },
      logout() {
        set({ token: null, refreshToken: null, usuario: null })
      },
      setToken(token) {
        set({ token })
      },
    }),
    {
      name: 'aurafleet-auth',
      partialize: (s) => ({
        token: s.token,
        refreshToken: s.refreshToken,
        usuario: s.usuario,
      }),
    },
  ),
)
